import React, { useState } from 'react'
import { colors } from '../style'

const Announcement = () => {
  const [isAccepted, setIsAccepted] = useState(false)

  return (
    <div
      css={[
        {
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100vw',
          background: `linear-gradient(to right, ${colors.brandDark}, ${colors.brandDark})`,
          zIndex: 2000,
          fontSize: 13,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem',
          color: 'white',
          letterSpacing: '-0.02em',
          button: {
            height: 'max-content',
            width: 'max-content',
            appearance: 'none',
            border: 'none',
            outline: 'none',
            padding: '0.125rem 0.25rem',
            borderRadius: '0.25rem',
            fontWeight: 700,
            fontSize: '0.75rem',
            marginLeft: '0.5rem',
          },
          a: {
            color: 'white',
            textDecoration: 'underline',
          },
        },
        isAccepted && { display: 'none' },
      ]}
    >
      <p>Rozpoczęliśmy proces integracji Stark Log sp. z o.o. z Omida VLS sp. z o.o. Udostępniamy <a href="https://omida-group.com/pdf/omidavls_starklog_plan_polaczenia.pdf">plan połączenia</a>.</p>
    </div>
  )
}

export default Announcement